import React from 'react';
import axios from 'axios';

const axiosInstance = axios.create({
    // baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.1.7:8080/v1' : 'http://localhost:8080/v1',
    baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.1.7:8080/v1' : 'https://cracklecart.com/v1',
    withCredentials: true // Include credentials (cookies) in requests
});

const setupInterceptors = (navigate) => {
    axiosInstance.interceptors.response.use(
        response => response,
        error => {
            console.log("error to get data from server " + error.code);
            if (error.code === 'ERR_NETWORK') {
                console.error('Network error:', error);
                // Handle network error (e.g., show a notification to the user)
            } else if (error.response && error.response.status === 401) {
                // Redirect to login page
                navigate("/web/signin");
                return;
            }
            // alert("its from axioSetup");
            // alert(error.code);
            return error.response;
        }
    );
};

export { axiosInstance, setupInterceptors };
